// @ts-nocheck
import * as Types from '../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type TestGroupDependenciesLineItemsQueryVariables = Types.Exact<{
  addonOptionId: Types.Scalars['ID']['input'];
  personalizationOptionGroupId: Types.Scalars['ID']['input'];
}>;


export type TestGroupDependenciesLineItemsQuery = { __typename?: 'Query', testGroupDependenciesLineItems: Array<{ __typename?: 'TakeoffLineItem', id: string, name: string, displayName: string, item: { __typename?: 'Item', id: string, fullCode: string, costCode: { __typename?: 'CostCode', id: string, number: string } }, location: { __typename?: 'Location', id: string, room?: { __typename?: 'Location', id: string, name: string } | null | undefined, parent?: { __typename?: 'Location', id: string, name: string } | null | undefined } }>, readyPlanOption: { __typename?: 'ReadyPlanOption', id: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, groupPrereqChildren: Array<{ __typename?: 'ReadyPlanOptionGroup', id: string, name: string }> } } };

export type TestGroupDependenciesModal_TakeoffLineItemFragment = { __typename?: 'TakeoffLineItem', id: string, name: string, displayName: string, item: { __typename?: 'Item', id: string, fullCode: string, costCode: { __typename?: 'CostCode', id: string, number: string } }, location: { __typename?: 'Location', id: string, room?: { __typename?: 'Location', id: string, name: string } | null | undefined, parent?: { __typename?: 'Location', id: string, name: string } | null | undefined } };

export const TestGroupDependenciesModal_TakeoffLineItemFragmentDoc = gql`
    fragment TestGroupDependenciesModal_TakeoffLineItem on TakeoffLineItem {
  id
  name
  displayName
  item {
    id
    fullCode
    costCode {
      id
      number
    }
  }
  location {
    id
    room {
      id
      name
    }
    parent {
      id
      name
    }
  }
}
    `;
export const TestGroupDependenciesLineItemsDocument = gql`
    query TestGroupDependenciesLineItems($addonOptionId: ID!, $personalizationOptionGroupId: ID!) {
  testGroupDependenciesLineItems(
    input: {addonOptionId: $addonOptionId, personalizationOptionGroupId: $personalizationOptionGroupId}
  ) {
    ...TestGroupDependenciesModal_TakeoffLineItem
  }
  readyPlanOption(id: $addonOptionId) {
    id
    optionGroup {
      id
      groupPrereqChildren {
        id
        name
      }
    }
  }
}
    ${TestGroupDependenciesModal_TakeoffLineItemFragmentDoc}`;

/**
 * __useTestGroupDependenciesLineItemsQuery__
 *
 * To run a query within a React component, call `useTestGroupDependenciesLineItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTestGroupDependenciesLineItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTestGroupDependenciesLineItemsQuery({
 *   variables: {
 *      addonOptionId: // value for 'addonOptionId'
 *      personalizationOptionGroupId: // value for 'personalizationOptionGroupId'
 *   },
 * });
 */
export function useTestGroupDependenciesLineItemsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<TestGroupDependenciesLineItemsQuery, TestGroupDependenciesLineItemsQueryVariables> & ({ variables: TestGroupDependenciesLineItemsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TestGroupDependenciesLineItemsQuery, TestGroupDependenciesLineItemsQueryVariables>(TestGroupDependenciesLineItemsDocument, options);
      }
export function useTestGroupDependenciesLineItemsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TestGroupDependenciesLineItemsQuery, TestGroupDependenciesLineItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TestGroupDependenciesLineItemsQuery, TestGroupDependenciesLineItemsQueryVariables>(TestGroupDependenciesLineItemsDocument, options);
        }
// @ts-ignore
export function useTestGroupDependenciesLineItemsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<TestGroupDependenciesLineItemsQuery, TestGroupDependenciesLineItemsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TestGroupDependenciesLineItemsQuery, TestGroupDependenciesLineItemsQueryVariables>;
export function useTestGroupDependenciesLineItemsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TestGroupDependenciesLineItemsQuery, TestGroupDependenciesLineItemsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TestGroupDependenciesLineItemsQuery | undefined, TestGroupDependenciesLineItemsQueryVariables>;
export function useTestGroupDependenciesLineItemsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TestGroupDependenciesLineItemsQuery, TestGroupDependenciesLineItemsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TestGroupDependenciesLineItemsQuery, TestGroupDependenciesLineItemsQueryVariables>(TestGroupDependenciesLineItemsDocument, options);
        }
export type TestGroupDependenciesLineItemsQueryHookResult = ReturnType<typeof useTestGroupDependenciesLineItemsQuery>;
export type TestGroupDependenciesLineItemsLazyQueryHookResult = ReturnType<typeof useTestGroupDependenciesLineItemsLazyQuery>;
export type TestGroupDependenciesLineItemsSuspenseQueryHookResult = ReturnType<typeof useTestGroupDependenciesLineItemsSuspenseQuery>;
export type TestGroupDependenciesLineItemsQueryResult = ApolloReactCommon.QueryResult<TestGroupDependenciesLineItemsQuery, TestGroupDependenciesLineItemsQueryVariables>;